// @ts-nocheck
import React, { useEffect, useState } from 'react'


const Input = ({ id, placeholder, label, required, onInputChange, regex, value: initialValue }) => {

    const [value, setValue] = useState(String(initialValue ?? ''));
    useEffect(() => setValue(String(initialValue ?? '')), [initialValue]);
    const maxLength = 255;
    const handleInputChange = event => {
        const newValue = event.target.value;
        setValue(newValue);
        onInputChange(label, event.target.value);
    };


    return (
            <div className="mb-6">
                <label htmlFor={`input-${id}`} className="mb-2 block text-sm font-semibold text-slate-800">
                    <span data-i18n-ignore="true">{label}</span> {required && <span className="text-red-500">*</span>}
                </label>
                <input
                    id={`input-${id}`}
                    type="text"
                    maxLength={maxLength}
                    value={value}
                    placeholder={placeholder}
                    data-i18n-ignore="true"
                    onChange={handleInputChange}
                    required={required}
                    className="block h-12 w-full rounded-xl border border-slate-300 bg-slate-50/60 px-4 text-sm text-slate-900 shadow-sm transition placeholder:text-slate-400 hover:border-slate-400 focus:border-emerald-600 focus:bg-white focus:ring-4 focus:ring-emerald-100"
                />

                <div className="mt-1.5 text-right text-xs font-medium text-slate-400">
                    {value.length}/{maxLength}
                </div>
            </div>
    )
}

export default Input
